import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {useHistory} from "react-router-dom";
import {useToast} from "@chakra-ui/react";
import {LogIn, LogOut, Maximize2, Monitor, Moon, Settings} from "lucide-react";
import {useLoggedIn, useStoreProfile} from "../../store";
import {useActions} from "../../app_context";
import useFeedback from "../../utils/use_feedback";
import useLogout from "../../api/logout";
import {useSaveSettings} from "../../api/user";
import {useSheetModal} from "../test/ModalContext";
import SignupPromptSheet from "./signup_prompt";
import Sheet, {MenuItem, MenuItemIcon, MenuItemText} from './sheet';

const SettingsSheet = styled(({className, onClose}) => {

    const {expand} = useStoreProfile();

    const actions = useActions();
    const history = useHistory();
    const settings = useStoreProfile();
    const loggedIn = useLoggedIn();
    const toast = useToast();
    const {feedbackCh} = useFeedback(true);
    const logout = useLogout(feedbackCh);
    const saveSettings = useSaveSettings();

    const { openModal } = useSheetModal();

    const handleTheme = async () => {
        onClose();
        const changes = {theme: settings.theme === 'light' ? 'dark' : 'light'};
        actions.settingsChanged(changes);
        try {
            await saveSettings(changes);
        } catch {}
    };

    const handleExpand = async () => {
        onClose();
        const changes = {expand: settings.expand === 'card' ? 'condensed' : 'card'};
        actions.settingsChanged(changes);
        try {
            await saveSettings(changes);
        } catch {}
    };

    const handleSettings = () => {
        onClose();
        if (loggedIn) {
            history.push(`/settings`);
        } else {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    const handleDesktop = () => {
        onClose();
        document.cookie = "forcePlatform=desktop; path=/; expires=Tue, 19 Jan 2038 03:14:07 UTC;";
        document.cookie = "forceDesktop=true; path=/; expires=Tue, 19 Jan 2038 03:14:07 UTC;";
        navigator.serviceWorker.ready.then((registration) => {
            registration.unregister().then(() => {
                window.location.reload(true);
            });
        });
    };

    const handleLogout = async () => {
        onClose();
        try {
            await logout();
            history.replace('/');
            toast({
                title: `Logged out!`,
                status: 'success',
                isClosable: true,
            });
        } catch {
            toast({
                title: `Failed to logout.`,
                status: 'error',
                isClosable: true,
            });
        }
    };

    const handleLogin = () => {
      onClose();
      history.push("/login");
    };

    return (
        <div className={className}>
            {!loggedIn &&
            <MenuItem onClick={handleLogin}>
                <MenuItemIcon>
                    <LogIn size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Log In
                </MenuItemText>
            </MenuItem>
            }
            <MenuItem onClick={handleTheme}>
                <MenuItemIcon>
                    <Moon size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Dark Mode
                </MenuItemText>
            </MenuItem>
            {loggedIn &&
                <MenuItem onClick={handleSettings}>
                    <MenuItemIcon>
                        <Settings size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Settings
                    </MenuItemText>
                </MenuItem>
            }
            <MenuItem onClick={handleExpand}>
                <MenuItemIcon>
                    <Maximize2 size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    {expand === 'card' ? 'Minimize Posts' : 'Expand Posts'}
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleDesktop}>
                <MenuItemIcon>
                    <Monitor size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Desktop Mode
                </MenuItemText>
            </MenuItem>
            {loggedIn &&
                <MenuItem onClick={handleLogout}>
                    <MenuItemIcon>
                        <LogOut size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Log Out
                    </MenuItemText>
                </MenuItem>
            }
        </div>
    );
})``;

export default SettingsSheet;
